
class AppLocalStorage {

    key = 'app-state'
    save (data) {
        return localStorage.setItem(this.key,JSON.stringify(data))
    }

    get () {
        try {
            let data =  localStorage.getItem(this.key)
            return JSON.parse(data)
        } catch (e) {
           return null
        }
    }
}

export default new AppLocalStorage()